import { render, staticRenderFns } from "./Appdownload.vue?vue&type=template&id=356cf2f3&scoped=true"
import script from "./Appdownload.vue?vue&type=script&lang=js"
export * from "./Appdownload.vue?vue&type=script&lang=js"
import style0 from "./Appdownload.vue?vue&type=style&index=0&id=356cf2f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356cf2f3",
  null
  
)

export default component.exports